import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import AOS from 'aos';

import 'Lib/jquery.hoverintent';
import 'Lib/jquery.scrolltofixed';
import 'Lib/jquery.scrollLock';

import * as track from '../track';
import OneDrawer from 'Modules/module-oneDrawer';
import OneSubscribe from 'Modules/module-oneSubscribe';
import OneMobileMenu from 'Modules/module-oneMobileMenu';


"use strict";

var ViewHeader = Backbone.View.extend({

    initialize: function (opts) {

        console.log('init header');

        var self = this;
        self.$body = self.$el;
        self.$header = $('header.site-header');
        self.$miniCart = $('#MiniCart');
        self.$mobileNav = $('#MobileNav');
        self.$searchBar = $('#SearchBar');
        self.$promoBanner = self.$header.find('.promo-banner');
        self.$navi = self.$header.find('nav');
        self.$menuToggle = self.$header.find('.menu-toggle');

        self.initPromoBanner();
        self.initFixedHeader();
        // self.initNavi();
        self.initUtilities();
        self.initSearch();
        // self.initMiniCart();
        self.warningModal();
        self.initMobileMenu();
        // self.initSubscribe();
        self.initFooter();
        self.backToTop();

        self.initCookieMessage();
        self.AnimateElementsbyAOS();
        self.isIE();
        self.devTools();

        self.initTracking();
        self.productRecommendations();
    },

    events: {
        'drawer-opt' : 'bodyClassCtl',
        'menu-opt' : 'bodyClassCtl',

        'click .nav-link': function(){
            $('.first-sub').addClass('hidden');
        },

        'mouseenter .site-nav': function(){
            $('.first-sub').removeClass('hidden');
        }
    },

    AnimateElementsbyAOS : function(e){
        var self = this;

        var events = {

        };

        AOS.init({
            offset: 0,
            duration: 300,
            easing: 'linear',
        });

    },

    bodyClassCtl : function(e){
        // Please prevent operation on more then one drawer at the same time
        var self = this;
        var type = e.type;
        if (type == 'drawer-opt') {
            self.$body.toggleClass('drawer-opt');
            self.$body.toggleClass('show-overlay');
        } else {
            self.$body.toggleClass('show-overlay');
        }
    },

    initPromoBanner: function(){
        var self = this;

        var lastScrollTop = 0;
        var promoBannerBodyClass = 'promo-banner-active';
        var promoBannerActiveClass = 'activate';
        var cookieEnabled = self.$promoBanner.data('cookieenabled');
        var cookieDays = self.$promoBanner.data('days');
        var prevScrollpos = window.pageYOffset;

        if(self.$promoBanner.length > 0){
            if(!ORW.utilities.getCookie('promo_banner')){
                // self.$body.addClass('promo-banner-active promo-banner-animate');
                self.$promoBanner.addClass('activate');
            }
        }

        window.onscroll = function() {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos || currentScrollPos < 100) {
                $(document).find('body').addClass('promo-banner-animate');
            } else {
                $(document).find('body').removeClass('promo-banner-animate');
            }

            prevScrollpos = currentScrollPos;
        }

        var events = {
            'click .close-promo' : function(e){
                self.$promoBanner.slideUp(200);
                self.$body.removeClass('promo-banner-active');
                self.$promoBanner.removeClass('activate');

                if(!ORW.utilities.getCookie('promo_banner') && cookieEnabled ){
                    ORW.utilities.setCookie('promo_banner','shown', cookieDays);
                }
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initFixedHeader: function() {
        var self = this,
            overClass = 'overHeader';

        var events = {
            'mouseenter .nav-bar,.header-utilities' : function(e){
                if(!self.$header.hasClass(overClass)){
                    // self.$body.addClass(overClass);
                    self.$header.addClass(overClass);
                }
            },
            'mouseleave .nav-bar,.header-utilities': function(e){
                if($(window).scrollTop() < self.$header.height()){
                    // self.$body.removeClass(overClass);
                    self.$header.removeClass(overClass);
                }
            }
        }

        var checkScroll = function(){
            var fixedClass = 'scrolled';
            if($(window).scrollTop() >= self.$header.height()){ self.$header.addClass(fixedClass); }
            if($(window).scrollTop() < self.$header.height()){ self.$header.removeClass(fixedClass); }

            const root = document.querySelector(':root');
            const header = document.querySelector('header');
            root.style.setProperty('--header-height', header.offsetHeight + 'px');
        };

        checkScroll();
        $(window).on("scroll",function(){
            checkScroll();
        });

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initUtilities: function() {
        var self = this;
        var events = {};

        // Header hover control
        self.$header.hoverIntent({
            over: function(){
                if (!self.isMobile()) self.$body.trigger('menu-opt');
            },
            out: function(){
                if (!self.isMobile()) self.$body.trigger('menu-opt');
            },
            sensitivity: 100,
            selector: '.has-dropdown',
        });

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    initSearch: function(){
        var self = this;

        self.searchCtl = OneDrawer.init({
            el: self.$body,
            drawerElem: '#' + self.$searchBar.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .search-toggle',
            openCallback: function(){
                setTimeout(function(){ self.$searchBar.find('input').focus(); },100);
                if(!self.$searchBar.hasClass('opened')){
                    self.$body.addClass('search-opened');
                    self.$header.find('.search-toggle').addClass('active');
                }else{
                    self.$body.removeClass('search-opened');
                    self.$header.find('.search-toggle').removeClass('active');
                }
            },
            events: {
                'click .search-form button' : function(e){
                    e.preventDefault();
                    var $form = $(e.currentTarget).parent('form');
                    if ($form.find('input').val()) {
                        this.closeDrawer();
                        $form.submit();
                        self.$body.removeClass('search-opened');
                        self.$header.find('.search-toggle').removeClass('active');
                    } else {
                        // May be show error message ...
                    }
                }
            }
        });
    },

    initMobileMenu: function(){
        var self = this;

        self.mobileMenuCtl = OneDrawer.init({
            el: self.$body,
            drawerElem: '#' + self.$mobileNav.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .menu-toggle'
        });

        self.mobileInnerMenuCtl = OneMobileMenu.init({
            el: self.$mobileNav
        });

        //Displays level 3 navigation items as level 2, and removes their parent.
        var level1 = self.$mobileNav.find(".level-1").filter(function() {
            return $(this).children("a.nav-link").children("span").text().toLowerCase() === "sale";
        });

        if (level1.length !== 0) {
            var level2DropDowns = level1.find(".level-2.has-children.has-dropdown");
            var level3 = level2DropDowns.find(".level-3");

            $(level3).each(function() {
                var level3Parent = $(this).closest(".level-2.has-children.has-dropdown")
                $("<div class='level-2'>" + $(this).html() + "</div>").insertBefore(level3Parent);
            });

            level2DropDowns.remove();
        }

        //Set "Shop" nav link to active, since it's already open.
        var level1Shop = self.$mobileNav.find(".level-1").filter(function() {
            return $(this).children("a.nav-link").children("span").text().toLowerCase() === "shop";
        });
        level1Shop.find(".nav-link").first().addClass("active");
        level1Shop.find(".children.dropdown.shop").addClass("active");
    },

    openMiniCart: function () {
        this.$miniCartContainer.addClass('force-open');

        if (this.isMobile()) {
        this.$body.addClass('minicart-active');
        }
    },

    closeMiniCart: function (event) {
        this.$miniCartContainer.removeClass('force-open');

        if (this.isMobile()) {
        this.$body.removeClass('minicart-active');
        }
    },

    startMiniCartEventWatchers: function () {
        this.$miniCartContainer.off();

        if (this.isMobile()) {
        this.$miniCartContainer.find('.block-title').on('touchstart', this.openMiniCart.bind(this));
        this.$miniCartContainer.find('h2>.icon-close').on('touchstart', this.closeMiniCart.bind(this))
        } else {
        this.$miniCartContainer.on('mouseleave', this.closeMiniCart.bind(this));
        }
    },

    initMiniCart: function () {
        var self = this;
        var $warningDrawer = $('.warning-drawer');

        self.miniCartCtl = OneDrawer.init({
            el: self.$body,
            drawerElem: '#' + self.$miniCart.attr('id'),
            triggerEvent: 'click',
            triggerElem: 'header .block-minicart',
            openCallback: function(){ ajaxCart.load(); }
        });

        ajaxCart.init({
            formSelector: '.add-to-cart-form',
            addToCartSelector: '.add-to-cart-btn',
            cartContainer: '#CartContainer',
            cartCountSelector: '.minicart-count',
            cartCostSelector: '#CartCost',
            moneyFormat: theme.moneyFormat
        });

        var events = {
            'mouseenter .block-minicart' : function(e){
                if (!this.isMobile() && !$('#MiniCart').hasClass('opened')) {
                    // self.$header.find('.block-minicart').trigger('click');
                    // self.miniCartCtl.openDrawer();
                    if(self.$miniCart.find('#CartContainer').text().length < 1){
                        self.$header.find('.block-minicart').trigger('click');
                    }else{
                        self.$body.addClass('show-overlay drawer-opt cart-opened');
                        self.$miniCart.addClass('opened');
                    }
                }
            },
            'mouseleave .block-minicart' : function(e){
                if (!this.isMobile() && $('#MiniCart').hasClass('opened')) {
                    // self.miniCartCtl.closeDrawer();
                    // self.$header.find('.block-minicart').trigger('click');
                    self.$body.removeClass('show-overlay drawer-opt cart-opened');
                    self.$miniCart.removeClass('opened');
                }
            },
            'click #MiniCart .remove.has-bundle': function(e){
                e.preventDefault();
                var line = $(e.currentTarget).data('line');
                $warningDrawer.find('.js-remove-item').attr('data-line', line);
                $warningDrawer.addClass('remove-from-minicart');
            }
        }

        $(document.body).on('afterAddToCart.ajaxCart', function(evt, cart) {
            if (self.miniCartCtl) {
                self.miniCartCtl.openDrawer();
                self.miniCartTimer = setTimeout(function(){ self.miniCartCtl.closeDrawer(); }, 5000);
            } else {
                self.openMiniCart();
                self.miniCartTimer = setTimeout(function(){ self.closeMiniCart(); }, 5000);
            }
        });

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },//initMiniCart

    warningModal: function(){
        var self = this;
        var $warningDrawer = $('.warning-drawer');
        OneDrawer.init({
            el: self.$body,                 // Make sure this scope covers all your trigger element and the Drawer, usually we use body
            drawerElem: '.warning-drawer', // Your drawer class or id
            triggerEvent: 'click',          // Trigger event
            triggerElem: '.remove.has-bundle', // Your drawer trigger id
            closeCallback: function(){
                $warningDrawer.removeClass('remove-from-minicart');
            },
            events: {   // Accept events key pairs
                'click .js-remove-item': function(e){
                    e.preventDefault();
                    var line = $(e.currentTarget).data('line');
                    if($warningDrawer.hasClass('remove-from-minicart')){
                        ShopifyAPI.changeItem(line, 0);
                        setTimeout(function() {
                            window.location.href = window.location.href;
                        }, 250);
                    }else{
                        window.location.href = $(e.currentTarget).attr('href');
                    }
                }
            }
        });

        var events = {
            'click .warning-drawer .cancel': function(e){
                $(e.currentTarget).closest('.drawer').find('.drawer-close').click();
            }
        };

        _.extend(self.events, events);
        self.delegateEvents();
    },

    initSubscribe: function() {
        var self = this;
        OneSubscribe.init({
            el: $('.subscribe-modal')
        });
    },

    initFooter: function() {
        var self = this;
        // From footer.liquid
        if ($('.footer-newsletter .form-success').length > 0) {
            var successFromTopPosition = $('.footer-newsletter').find('.form-success').position().top;
            $("html, body").animate({scrollTop: successFromTopPosition},400);
        }
    },

    backToTop: function(){
        var self = this;
        var events = {
            'click .footer-back-to-top .back-to-top': function(e){
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        };

        _.extend(self.events, events);
        self.delegateEvents();
    },

    initCookieMessage: function(){
        var self = this;
        var $cookiesBox = $('.cookies-message');
        var cookieDays = 90;

        if($cookiesBox.length > 0){
            if(!ORW.utilities.getCookie('cookies_message')){
                self.$body.addClass('cookies-message-active');
                $cookiesBox.addClass('activate');
            }
            else{
                self.initSubscribe();
            }
        }

        var events = {
            'click .close-message,.accept-message' : function(e){
                self.$body.removeClass('cookies-message-active');
                $cookiesBox.removeClass('activate');
                self.initSubscribe();

                if(!ORW.utilities.getCookie('cookies_message')){
                    ORW.utilities.setCookie('cookies_message','shown', cookieDays);
                }
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    isIE: function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var msEdge = ua.indexOf("Edge ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){ // If Internet Explorer, return version number
            $('body').addClass('is-ie');
            return true;
        }else if(msEdge > 0){
            $('body').addClass('is-edge');
            return true;
        }else{  // If another browser, return 0
            return false;
        }
    },

    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w <= ORW.responsiveSizes.large) {
            return true;
        }
        return false;
    },

    devTools: function(){
        var self = this;
        var $indicator = $('#responsive-indicator');
        var $previewBar = $('#preview-bar-iframe');

            // This should only run when a theme is being previewed.
        if(typeof Shopify.PreviewBarInjector !== undefined){
            if($indicator.length > 0 && $previewBar.length > 0 && Shopify.PreviewBarInjector.length == 1){
                $indicator.text("Preview: " + Shopify.theme.name).removeClass("hide-important");

                $indicator.click(function(e){
                    $indicator.toggleClass('active');
                    $previewBar.toggleClass('active');
                });

            }else{
                $indicator.addClass("hide-important");
            }
        }
    },

    initTracking: function () {
        var cache = window.ORW.caches.products;

        // clear mrv product

        if (!/\/products\//.test(window.location.href)) {
            window.ORW.utilities.deleteCookie('mrv_product');
        }

        // impressions & clicks (plp, search, pdp recs, cart, minicart)

        track._.onCreate(
            document.body,
            [
                'article.item[data-handle]:not([data-handle*="."]):not(.ajaxcart__product)',
                // 'form[action="/cart"] .cart-detail .item-row[data-handle]',
            ].join(','),
            function (item) {
                var handle = item.dataset.handle;

                var variantId = null;
                try {
                    var link = item.querySelector('a[href*="/products/"]');
                    variantId = link.href.match(/variant=([^&#]+)/)[1];
                } catch (_) {}

                var list = (function () {
                    var pathname = window.location.pathname;

                    if (item.matches('.ajaxcart__product')) return 'minicart';
                    if (/\/cart$/.test(pathname)) return 'cart';
                    if (/\/collections\//.test(pathname)) return track._.getHandleForPathname();
                    if (/\/products\//.test(pathname)) return 'product-recommended';
                    if (/\/search$/.test(pathname)) return 'search';

                    console.warn('unknown list!', item);
                    return;
                })();

                var clickType = (function () {
                    if (list === 'product-recommended') return 'template-product-recommended';
                    if (list === 'minicart') return 'minicart';

                    return Array.from(document.body.classList).find(function (className) {
                        return /^template-/.test(className);
                    });
                })();

                var position = function () {
                    return track._.getElementIndex(item, [
                        'article.item[data-handle]:not([data-handle*="."])',
                        'form[action="/cart"] .cart-detail .item-row[data-handle]',
                    ].join(',')) + 1;
                };

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        }) || product.variants[0];

                        track.productImpression(product, list, position());

                        track._.onCreate(
                            item,
                            'a[href*="/products/"]',
                            function (link) {
                                link.addEventListener('click', function () {
                                    track.productClick(product, clickType, list, position());
                                });
                            }
                        )
                    });
            }
        );

        // impressions & clicks (preview search)

        track._.onCreate(
            document.body,
            '#SearchBar ul li',
            function (li) {
                var position = function () {
                    return track._.getElementIndex(li) + 1;
                };

                track._.onCreate(
                    li,
                    'a[href*="/products/"]',
                    function (link) {
                        var handle = track._.getHandleForPathname(link.pathname);

                        var variantId = null;
                        try {
                            variantId = link.href.match(/variant=([^&#]+)/)[1];
                        } catch (_) {}

                        cache.get('/products/' + handle + '.js')
                            .done(function (_product) {
                                var product = JSON.parse(JSON.stringify(_product));
                                product.variant = product.variants.find(function (variant) {
                                    return variant.id.toString() === variantId;
                                }) || product.variants[0];

                                track.productImpression(product, 'preview-search', position());

                                link.addEventListener('click', function () {
                                    track.productClick(product, 'preview-search', 'preview-search', position());
                                });
                            });
                    }
                );
            }
        );

        // atb from pdp/qs

        track._.onCreate(
            document.body,
            'form[action="/cart/add"][data-product-handle]',
            function (form) {
                var handle = form.dataset.productHandle;
                var variantId = null;

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));

                        form.addEventListener('submit', function () {
                            variantId = form.elements.id.value;
                            product.variant = product.variants.find(function (variant) {
                                return variant.id.toString() === variantId;
                            });

                            track.addToBag(product, +form.elements.quantity.value);
                        });
                    });
            }
        );

        // qty adjust from minicart

        track._.onCreate(
            document.body,
            'select.ajaxcart__qty-num[data-handle][data-id]',
            function (select) {
                var handle = select.dataset.handle;
                var key = select.dataset.id;
                var variantId = key.split(':').shift();

                var quantityWas = +select.value;

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        });

                        select.addEventListener('change', function () {
                            track._.onCreate(
                                document.querySelector('header .header-block.block-minicart'),
                                'select.ajaxcart__qty-num[data-handle][data-id="' + key + '"]',
                                function (select) {
                                    var quantityIs = +select.value;
                                    track.addToBag(product, quantityIs - quantityWas);
                                },
                                { dataSeen: 'seent', initial: false, once: true }
                            );
                        });
                    });
            }
        );

        // qty adjust from cart

        track._.onCreate(
            document.body,
            'form[action="/cart"] .cart-detail select[data-item-handle][data-item-key]',
            function (select) {
                var handle = select.dataset.itemHandle;
                var key = select.dataset.itemKey;
                var variantId = key.split(':').shift();

                var quantityWas = +select.value;

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        });

                        select.addEventListener('change', function () {
                            var quantityIs = +select.value;
                            track.addToBag(product, quantityIs - quantityWas);
                            quantityWas = quantityIs;
                        });
                    });
            }
        );

        // remove from bag from minicart

        track._.onCreate(
            document.body,
            '.ajaxcart__qty-remove[data-handle][data-id]',
            function (link) {
                var handle = link.dataset.handle;
                var key = link.dataset.id;
                var variantId = key.split(':').shift();
                var quantity = +link.dataset.quantity;

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        });

                        link.addEventListener('click', function () {
                            track.addToBag(product, -quantity);
                        });
                    });
            }
        );

        // remove from bag from cart

        track._.onCreate(
            document.body,
            'form[action="/cart"] .cart-detail .remove[data-item-handle][data-item-key]:not(.has-bundle)',
            function (link) {
                var handle = link.dataset.itemHandle;
                var key = link.dataset.itemKey;
                var variantId = key.split(':').shift();

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        });

                        link.addEventListener('click', function () {
                            var quantity = +link.dataset.quantity;
                            track.addToBag(product, -quantity);
                        });
                    });
            }
        );

        track._.onCreate(
            document.body,
            '.quick-buy',
            function(link) {
                var handle = link.dataset.productHandle;
                var variantId = link.dataset.variantId;

                cache.get('/products/' + handle + '.js')
                    .done(function (_product) {
                        var product = JSON.parse(JSON.stringify(_product));
                        product.variant = product.variants.find(function (variant) {
                            return variant.id.toString() === variantId;
                        });

                        link.addEventListener('click', function () {
                            var quantity = +link.dataset.quantity;
                            track.quickShopClick(product, -quantity);
                        });
                    });
            }
        );
    },

    productRecommendations: function () {
        let self = this;

        self.activeClass = 'active';
        self.$productRecommendationsModule = self.$body.find('.product-recommendations');
        self.$tabs = self.$productRecommendationsModule.find('.tabbed-module');

        if (!self.$tabs) return;

        self.$tabTitles = self.$tabs.find('.tabbed-title-wrap .tabbed-title');

        let clickHandler = function (e) {
            e.preventDefault();

            const $tabTitle = $(this);
            const $tabTitleWrap = $tabTitle.parents('.tabbed-title-wrap');
            const $tabContentTarget = $tabTitle.data('target');

            console.log('$tabContentTarget', $tabContentTarget);

            if ($tabTitle.hasClass(self.activeClass)) return;

            $tabTitleWrap.find('.tabbed-title.active').removeClass(self.activeClass);
            $tabTitle.addClass(self.activeClass);

            const $tabContentWrap = $tabTitleWrap.siblings('.tabbed-content-wrap');
            $tabContentWrap.children().removeClass(self.activeClass);
            $tabContentWrap
                .find(`.tabbed-content[data-target="${$tabContentTarget}"]`)
                .addClass(self.activeClass);
        };

        self.$tabTitles.on('click',clickHandler);

    }

});

export default ViewHeader;
